import { Popover as PopoverBase } from 'antd';
import { PopoverProps } from 'antd/lib/popover';
import React from 'react';

export interface IPopoverProps extends PopoverProps {}

const Popover: React.FC<IPopoverProps> = ({ children, ...props }) => {
  return <PopoverBase {...props}>{children}</PopoverBase>;
};

export default Popover;
